import { useMemo } from "react"

import { Dropdown, Flex, Text } from "@/atoms"
import { DownOutlined } from "@/icons"
import { getAllEnvironmentOption } from "@/pages/DashboardPage/selectors/inventory.selector"
import { useFiltersDeployments } from "@/pages/DeploymentsPage/application/useFiltersDeployments"

import styles from "./HeaderDeploymentsTab.module.scss"

import type { Dispatch, SetStateAction } from "react"

export const EnvironmentDropdown = (props: {
  state: [
    { key: string; label: string } | undefined,
    Dispatch<SetStateAction<{ key: string; label: string } | undefined>>
  ]
}) => {
  const { response, isLoading } = useFiltersDeployments()

  const items = useMemo(() => {
    if (!response?.environments) return []

    return [
      getAllEnvironmentOption(),
      ...response.environments.map(({ value }) => ({
        value,
        label: value,
        key: value
      }))
    ]
  }, [response])

  return (
    <Dropdown
      disabled={isLoading}
      classNames={{ root: styles.dropdown }}
      menu={{
        items,
        onClick: ({ key }) => {
          if (key === getAllEnvironmentOption().key)
            return props.state[1](undefined)

          props.state[1](items.find((item) => item.key === key))
        }
      }}
    >
      <Text className={styles.dropdownText}>
        <Flex gap={10} align="center">
          {props.state?.[0]?.label || getAllEnvironmentOption().label}
          <DownOutlined className={styles.dropdownIcon} />
        </Flex>
      </Text>
    </Dropdown>
  )
}
